
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/the-program",
      function () {
        return require("private-next-pages/the-program.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/the-program"])
      });
    }
  